export default __webpack_public_path__ + "static/media/Gabi.83c5cc01.jpg";